import { Chip, Grid } from '@mui/material';
import {
	BulkInventoryItem,
	InventoryStatus,
	isInventoryStatus,
	SingleInventoryItem,
} from 'common/modules/inventory';
import React from 'react';
import { useTranslation } from 'services/localization';
import { getInventoryStatusTranslation } from '../utils';

interface Props {
	value: SingleInventoryItem['status'] | BulkInventoryItem['statuses'];
	chipColoring?: 'neutral' | 'success' | 'error' | 'default';
}

const SINGLE_ITEM_STATUS_VALUE = -1;

export const StatusCell = (props: Props) => {
	const { t } = useTranslation();
	const statuses: BulkInventoryItem['statuses'] =
		typeof props.value === 'string' ? { [props.value]: SINGLE_ITEM_STATUS_VALUE } : props.value;

	const getInventoryStatusColor = (status: InventoryStatus) => {
		if (props.chipColoring === 'neutral') return 'default';
		if (props.chipColoring === 'success') return 'success';
		if (props.chipColoring === 'error') return 'error';
		const statusColorMap: Record<
			InventoryStatus,
			'success' | 'default' | 'error' | 'info' | 'secondary' | 'warning'
		> = {
			IN_USE: 'default',
			OUT_OF_USE: 'error',
			LOST: 'warning',
			SOLD: 'secondary',
		};
		return statusColorMap[status] ?? 'default';
	};

	return (
		<Grid container spacing={1} flexWrap="nowrap">
			{Object.entries(statuses)
				.filter(([status]) => isInventoryStatus(status))
				.map(([_status, qty], idx) => {
					const status = _status as InventoryStatus;
					if (Number(qty) === 0) return null;
					const localizedStatus = getInventoryStatusTranslation(t, status);
					const name =
						qty === SINGLE_ITEM_STATUS_VALUE ? localizedStatus : `${localizedStatus}: ${qty}`;
					return (
						<Grid key={`${name}_${idx}`} item>
							<Chip
								size="small"
								color={getInventoryStatusColor(status)}
								variant="outlined"
								label={name}
							/>
						</Grid>
					);
				})}
		</Grid>
	);
};
